export default __webpack_public_path__ + "static/media/the-rage-face-82.bf734aaf.png";